/**
 * @param   value a Number or a String to be transformed
 * @param   decimalPlaces how many decimals you would like to place
 * @returns a string rounded by given decimal
 */
export function toFixedDecimalPoint(value: number | string = '', decimalPlaces = 0): string {
    if (value === '') return '';

    let valFloat = parseFloat(value.toString().replace(/,/g, ''));
    valFloat = Number.isNaN(valFloat) ? 0 : valFloat;

    return valFloat.toFixed(decimalPlaces);
}

/**
 * @param   value a Number to be transformed
 * @param   decimalPlace how many decimals you would like to place
 * @returns a string with decimal or not
 */
export function formatMinDecimalPlace(value: number, decimalPlace = 0): string {
    if (value === null || value === undefined) {
        // eslint-disable-next-line no-console
        console.error('invalid value:', value);
        return '';
    }

    const split = String(value).split('.');
    const currentDecimalPlaceLength = split[1] ? split[1].length : 0;

    return value.toFixed(
        Math.max(currentDecimalPlaceLength, decimalPlace),
    );
}
